import React from 'react';
import { I18n } from 'react-redux-i18n';

import FIELDS from '../../../../data/fields';

class HasUser extends React.PureComponent {
  setStateProp = async (e) => {
    await this.props.setStateProp(e);
  };

  render() {
    const {
      hasUser, userId, password, passwordConfirm,
    } = this.props;

    if (hasUser && userId) return null;

    return (
      <React.Fragment>
        <div className="form-group">
          <input
            type="password"
            className="form-control"
            placeholder={I18n.t('password')}
            onChange={e => this.setStateProp({
              password: e.target.value,
              message: '',
              success: '',
            })}
            value={password}
            maxLength={FIELDS.password_max}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            className="form-control"
            placeholder={I18n.t('confirmPassword')}
            onChange={e => this.setStateProp({
              passwordConfirm: e.target.value,
              message: '',
              success: '',
            })}
            value={passwordConfirm}
            maxLength={FIELDS.password_max}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default HasUser;
